import type { DocumentoNotificacao } from '../../types/documentoNotificacao.types';
import { lerDocumentoNotificacao } from '../../utils/documentoNotificacao';
import { extrajudicialService } from '../services';

export async function consultarDocumentoNotificacao(
  numeroNotificacao: string,
  signal: AbortSignal,
): Promise<DocumentoNotificacao | null> {
  const item = await extrajudicialService.obterItem(numeroNotificacao, signal);
  return lerDocumentoNotificacao(item.documentoNotificacao);
}
